module.exports = __webpack_public_path__ + "img/practice-4.0e19cc3f.jpg";